import { Injectable } from "@angular/core";
import { ReportsProvider } from "../../providers/reports/reports";
import { SolicitacaoContatoModel } from "./solicitacao-contato.modelview";
import { Observable } from "rxjs/Observable";
import { ListasProvider } from "../../providers/listas/listas";
import { UserProvider } from "../../providers/user/user";

@Injectable()
export class SolicitacaoContatoPageProvider {
    constructor(public reportProvider: ReportsProvider, 
        public userProvider: UserProvider,
        public listasProvider: ListasProvider) { }

    solicitarContato(model: SolicitacaoContatoModel): Observable<boolean> {
        return Observable.create(observe => {
            this.reportProvider.solicitarContato(model.forma_contato, model.data, model.hora, model.especialidade).subscribe(data => {
                observe.next(true)
            }, err => {
                observe.error(err)
            })
        })
    }

    requestLists(): Observable<any> {
        return this.listasProvider.requestAllLists()
    }


    getUserData(): Observable<any> {
        return Observable.create(subscribe => {
            subscribe.next(this.userProvider.getUserStoraged())
        })
    }
}


// WEBPACK FOOTER //
// ./src/pages/solicitacao-contato/solicitacao-contato.provider.ts